import { render, staticRenderFns } from "./PigmentView.vue?vue&type=template&id=4ace0248&scoped=true"
import script from "./PigmentView.vue?vue&type=script&lang=js"
export * from "./PigmentView.vue?vue&type=script&lang=js"
import style0 from "./PigmentView.vue?vue&type=style&index=0&id=4ace0248&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ace0248",
  null
  
)

export default component.exports